module.exports = __webpack_public_path__ + "img/login_content.d06389fd.jpg";